<template>
  <div>
    <section-definition title="Grader Home"></section-definition>
    <v-container fluid>

      <v-layout>
        <v-flex grow></v-flex>
        <v-flex shrink>
          <v-menu
                  v-model="date_menu1"
                  :close-on-content-click="false"
                  :nudge-right="0"
                  lazy
                  transition="scale-transition"
                  offset-y
                  nudge-bottom="30"
                  full-width
                  max-width="290px"
                  min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="date_month"
                      label="Pick Month To View"
                      prepend-icon="event"
                      v-on="on"

              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="date_month"
                    @input="date_menu1 = false"
                    no-title
                    type="month"
                    v-on:change="get_data"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex shrink v-if="show_admin_view" pl-2>
          <v-autocomplete
                  :items="graders"
                  label="Grader"
                  v-model="selectedGrader"
                  item-value="user_id"
                  item-text="name"
                  v-on:change="get_data"
          ></v-autocomplete>
        </v-flex>
      </v-layout>




      <!--main layout for dealer cards--------------------------------------------------------------------------------->
      <v-layout wrap>
        <v-flex
            xs12 sm6 md4
            v-for="(item, i) in dealers"
            :key="item._id"
            pa-1
        >
          <v-card>
            <v-card-title color="accent">
              <div style="width: 100%;" class="my-header"><v-icon>business</v-icon> {{item.org_id.name}} </div>
              <div style="width: 100%;" class="my-header"><v-icon>directions_car</v-icon> {{item.name}}</div>
            </v-card-title>
            <v-divider></v-divider>


            <v-card-text>
              <div class="my-header">Leads For Dealership:</div>
              <div class="my-explainer">
                Total / Graded / Remaining
              </div>
              <div>
                <v-chip class="chip-total">{{item.total_leads_to_grade}} Total</v-chip>
                <v-chip class="chip-graded">{{item.total_leads_graded}} Graded</v-chip>
                <v-chip :class="pill_class(item.total_leads_to_grade - item.total_leads_graded)">
                  {{item.total_leads_to_grade - item.total_leads_graded}} To Grade
                </v-chip>
              </div>
            </v-card-text>

            <v-divider></v-divider>


            <v-card-text>
              <div class="my-header">By Sales Agent:</div>
              <div class="my-explainer">
                Total / Graded / Remaining
              </div>
            </v-card-text>

            <v-card-text style="padding-top:0px; max-height: 300px; overflow-y: scroll">
              <div class="sp-block"
                v-for="(sp, j) in item.sales_people"
                :key="sp.name"
              >

                <div style="font-size: large;">
                  <span >{{ sp.name }}</span> <br>
                  <v-chip small pill class="chip-total">

                    {{item.leads_per_salesperson}} Total
                  </v-chip>
                  <v-chip small pill class="chip-graded">{{sp.count}} Graded</v-chip>
                  <!--<v-chip-->
                          <!--small pill-->
                          <!--class="chip-remain"-->
                          <!--style="cursor: pointer;"-->
                          <!--@click="$router.push({path: 'grade-ism', query:{dealer_id: item._id, user_id: sp.user_id}})"-->
                  <!--&gt;{{item.leads_per_salesperson - sp.count}} To Grade</v-chip>-->

                    <v-chip small pill :class="pill_class(item.leads_per_salesperson - sp.count)">
                    <span class="pr-1">{{item.leads_per_salesperson - sp.count}}</span>
                    <router-link
                        style="color:black;"
                        :to="'/grade-ism?dealer_id='+item._id+'&user_id='+sp.user_id"
                        v-if="item.leads_per_salesperson > sp.count"
                    >
                      To Grade
                    </router-link>
                      <span v-else>To Grade</span>
                  </v-chip>


                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex v-if="dealers.length===0">
          No dealers assigned for this grader.
        </v-flex>

      </v-layout>


    </v-container>
  </div>
</template>


<style scoped>
  .my-header{
    font-size: large;
  }

  .my-explainer{
    font-size: x-small;
    color: #484848;
  }

  .sp-block{
    padding-bottom: 15px;
    padding-left: 10px;
  }

  .chip-total{
    background-color: #dadada;
    font-weight: bold;
  }
  .chip-graded{
    background-color: rgba(26, 255, 38, 0.43);
    font-weight: bold;
  }
  .chip-remain{
    background-color: rgba(255, 2, 0, 0.55);
    font-weight: bold;
    cursor: pointer;
  }
</style>


<script>

   // import axios from 'axios';
   // import validate from '../mixins/validation';
   import data_getters from '../mixins/data_getters';


   export default {
      mixins: [data_getters],
      data() {
         return {
            dealers: [],

            date_menu1: false,
            date_month: null,

            //used for admin view
            graders: [],
            selectedGrader: null,

            chip_cl_total: '#e7e7e7',
            chip_cl_graded: '#40e73f',
            chip_cl_remain: 'rgba(255, 0, 0, 0.3)', //'#ff2e19',

         };
      },
      methods: {

         pill_class(val){
           if ( val > 0) return 'chip-remain';
           else return 'chip-graded'
         },

         async get_graders(){
            if (this.show_admin_view){
               let data  = await Promise.all([this.get_users({user_role: 'Grader', is_active:true}), this.get_users({user_role: 'AcctManager', is_active:true})  ]);

               this.graders = data[0].concat(data[1]);
               this.graders.sort((a, b) => (a.name > b.name) ? 1 : -1);
               if (this.graders.length > 0){
                  this.selectedGrader = this.graders[0].user_id;
               }
            }
         },

         async get_data(){
            let bdate = this.date_month + '-01';
            let edate = this.get_eom(bdate);
            let grader_id;
            // console.log(bdate, edate)


            if (this.show_admin_view){
               grader_id = this.selectedGrader;
            }
            else{
               grader_id = this.$auth.profile.sub
            }

            let dealers = await this.get_dealers({grader_id});
            // this.dealers = JSON.parse(JSON.stringify(dealers));


            // get  graded leads for each sales person for each dealership
            for (let i=0; i < dealers.length; i++){
               let k=i; //creating a local variable here to be used in the callback passed to get_users()

               let num_grades = dealers[i].leads_per_salesperson;

               //needed as a placeholder while waiting for user data to be returned
               dealers[i].sales_people = [];
               dealers[i].total_leads_to_grade = 0;
               dealers[i].total_leads_graded = 0;
               dealers[i].total_remaning_leads = 0;

               let dealer_id = dealers[i]._id;
               this.get_report_card_data({bdate, edate, dealer_id, groupby:'salesperson', user_role: 'SalesPerson'})
                  .then(data =>{
                     this.dealers[k].sales_people = data.sort((a, b) => a.name > b.name? 1 : -1);
                     this.dealers[k].total_leads_to_grade = data.length*num_grades;
                     this.dealers[k].total_leads_graded = 0;

                     for (let j=0; j<data.length; j++){
                        this.dealers[k].total_leads_graded += data[j].count;
                     }

                     this.dealers[k].total_remaning_leads = this.dealers[k].total_leads_to_grade - this.dealers[k].total_leads_graded;

                  }).catch(err=>{
                     // eslint-disable-next-line
                     console.error(err);
                  });

            }
            this.dealers = JSON.parse(JSON.stringify(dealers));
            //note this defines the "this.dealer" object, but the values for the sales_people prop are updated
            //asynchronously as data is returned.
         },

      },
      computed:{

         show_admin_view(){
            return ['Admin', ].includes(this.$auth.profile.user_role);
         }
      },
      async created(){
         await this.get_graders();
         this.date_month =  new Date().toISOString().slice(0, 7);
         this.get_data();

      }
   };
</script>
